// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3hYob","header":"PatientQuestionnaire_header__3P9TH","info":"PatientQuestionnaire_info__3uhS1"};